/**
 * Первопартийный каталог имён событий (единый источник правды для клиентского SDK,
 * ingest-валидации и rollup-логики). Строковые значения совпадают с разметкой
 * GA4/Метрики, чтобы первопартийные данные сходились с внешней аналитикой.
 */
export enum EAnalyticsEvent {
    SessionStart = 'session_start',
    PageView = 'page_view',
    CalculatorOpen = 'calculator_open',
    CalculatorParamChange = 'calculator_param_change',
    CalculatorResult = 'calculator_result',
    CtaOrderClick = 'cta_order_click',
    CtaContactClick = 'cta_contact_click',
    FormOpen = 'form_open',
    FormSubmitSuccess = 'form_submit_success',
    FormSubmitError = 'form_submit_error',
    PhoneClick = 'phone_click',
    MessengerWhatsappClick = 'messenger_whatsapp_click',
    MessengerTelegramClick = 'messenger_telegram_click',
    MessengerViberClick = 'messenger_viber_click',
    PdfDownload = 'pdf_download',
    ShareClick = 'share_click',
    LeadSubmit = 'lead_submit',
    WebVital = 'web_vital',
    Error = 'error',
}

/** Плоский список всех имён событий каталога (для ingest-проверки «имя известно»). */
export const ANALYTICS_EVENT_NAMES: readonly EAnalyticsEvent[] = Object.values(EAnalyticsEvent);

/** True, если строка — известное имя события каталога. */
export function isAnalyticsEventName(value: string): value is EAnalyticsEvent {
    return (ANALYTICS_EVENT_NAMES as readonly string[]).includes(value);
}
